import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"arrow\"><path d=\"M6.34 0 12 6l-5.66 6-1.2-1.26 3.6-3.82H0V5.08h8.74l-3.6-3.81L6.34 0Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol